<div class="wrapper">
  <div class="label-wrapper"
       appFV
       [appFVControl]="passedFormControl"
       [appFVDisabled]="!enableValidation"
       [appFVOverlayMarker]="menuMarkerClass"
       [appFVOnlyBorder]="onlyErrorBorder"
       [class.is-hover]="panelMenuTrigger.menuOpen">
    <label (click)="fieldClick()" #labelElement>
      <!--         [ngClass]="{'gl-border-error': invalid }">-->
      <span class="field-label" *ngIf="showFixedLabel"
            [class.hidden]="labelAnimation">{{ label || placeholder }}</span>
      <span class="gl-d-flex">
        <input
          type="text"
          [name]="randomName"
          [id]="randomName"
          (blur)="onSearchBlur()"
          spellcheck="false"
          [autocomplete]="randomName"
          [placeholder]="labelAnimation ? '' : placeholder"
          [formControl]="searchControl"
          [readOnly]="isDisabled"
          [ngClass]="{'animated-label': labelAnimation, 'disable-form-error': true}"
          #searchInput
        />

        <span class="field-label"
              [class.active]="panelMenuTrigger.menuOpen || !!searchInput.value"
              *ngIf="showAnimatedLabel">{{ label || placeholder }}</span>

        <span class="trigger" (click)="iconClick($event)"
              [class.center-pos]="showFixedLabel">
          <mat-icon>
            {{ searchControl.value ? 'close' : triggerIcon }}
          </mat-icon>
        </span>
      </span>
    </label>
  </div>

  <button class="menu-trigger" [matMenuTriggerFor]="panelMenu"
          #panelMenuTrigger="matMenuTrigger">
  </button>

  <mat-menu #panelMenu [classList]="menuMarkerClass + ' ' + 'single-select-menu'">
    <div class="panel" [style.width.px]="panelWidth">
      <ng-container *ngIf="messageAsResult">
        <ng-container *ngTemplateOutlet="message"></ng-container>
      </ng-container>
      <ng-container *ngIf="!messageAsResult">
        <ng-container *ngIf="list$ | async as list; else spinner">
          <ng-container *ngIf="isLoading">
            <ng-container *ngTemplateOutlet="spinner"></ng-container>
          </ng-container>
          <mat-option *ngIf="!isLoading && searchHasBeenDone && list.length === 0" class="message-as-result">
            <span i18n>Ничего не найдено</span>
          </mat-option>
          <mat-option *ngFor="let item of list"
                      (onSelectionChange)="optionSelected(item)"
                      [value]="item">
            {{ item }}
          </mat-option>
        </ng-container>
      </ng-container>
    </div>
  </mat-menu>
</div>

<ng-template #spinner>
  <div class="spinner-wrapper">
    <app-spinner [size]="'2.5rem'"></app-spinner>
  </div>
</ng-template>

<ng-template #message>
  <div class="message-as-result">
    {{messageAsResult}}
  </div>
</ng-template>

